module.exports = __webpack_public_path__ + "static/media/b3.d61f1178.jpg";